<template>
  <section>
    <Header>
      <div class="flex-grow-1"></div>
      <v-toolbar-items class="mr-4">
        <v-btn class="backbtn" depressed @click="backtomain()">principale</v-btn>
      </v-toolbar-items>
    </Header>
    <v-container>
    <div class="print-pdf">
      <v-btn class="btns" dark small @click="createPdf"
        ><span>genera pdf</span></v-btn>
    </div>
      <div id="print" v-if="kanjiData">
        <section slot="pdf-content">
          <section class="pdf-item">
            <table id="kanji-table" aria-label="Scheda kanji">
              <tr>
                <td rowspan="3" class="literal">{{ kanjiData.literal }}</td>
                <th scope="row">オン読み</th>
                <td>{{ reads("on") }}</td>
                <th scope="row">画数</th>
                <td>{{ kanjiData.misc.stroke_count }}</td>
              </tr>
              <tr>
                <th scope="row">くん読み</th>
                <td>{{ reads("kun") }}</td>
                <th scope="row">JLPT</th>
                <td>{{ reads("kun") }}</td>
              </tr>
              <tr>
                <td colspan="2">{{ ita || eng }}</td>
                <th scope="row">部首</th>
                <td>
                  <b>{{ kanjiData.radical.rad_string.radical.join(" ") }}</b>
                  ({{ kanjiData.radical.rad_string.name.join(", ") }})
                </td>
              </tr>
            </table>
          </section>
          <section>
            <div class="blocks example" id="strokesblock"></div>
            <div class="blocks" id="strokesgrey"></div>
            <div class="blocks" id="strokesonly"></div>
            <div class="blocks" id="gridonly"></div>
            <hr />
            <hr />
            <hr />
            <hr />
            <hr />
            <hr />
            <hr />
            <hr />
          </section>
        </section>
      </div>
    </v-container>
  </section>
</template>

<script>
import "dmak/dist/dmak.js";
import axios from "axios";
import "@/helpers/prototyped.js";
import html2Pdf from "html2pdf.js";
//import VueHtml2pdf from 'vue-html2pdf'
import { EkDetailsMixin } from "@/components/EkDetailsMixin.js";
import { KanjiBlocksMixin } from "@/components/KanjiBlocksMixin.js";
import Header from "@/components/Header.vue";
export default {
  mixins: [EkDetailsMixin, KanjiBlocksMixin],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  watch: {
    kanjiData: function(val) {
      this.apiCall(this.kanjiData.literal).then((svg) => {
        this.strokeBlocks(svg.data, "strokesblock", "", { width: 70 });
        this.strokeBlocks(svg.data, "strokesgrey", "grey", { width: 70 });
        this.strokesOnly(svg.data, "strokesonly", { width: 70, items: 20 });
        this.gridOnly("gridonly", { width: 70, items: 20 });
      });
    },
  },
  methods: {
    backtomain() {
      this.$router.push("/kanji/" + this.kanjiData.literal);
    },

    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    hasGenerated(e) {
      alert(1);
    },
    async loadsvg() {
      /* spostato sul mixin */
    },
    frame() {},
    createPdf() {
      var p = document.getElementById("print");
      var opt = {
        margin: 2,
        filename: "edukanji-sheet.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          format: "a4",
          orientation: "portrait",
        },
      };

      //html2Pdf().set(opt).from(p).save();
      html2Pdf()
        .from(p)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function(pdf) {
          let totalPages = pdf.internal.getNumberOfPages();
          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text("Edukanji", 10, 12);
          }
        })
        .save();
    },

    renderKanji() {},
  },
  components: {
    Header,
  },
};
</script>

<style scoped>
#print {
  padding: 16px;
  margin-top: 32px;
  font-family: "UD デジタル 教科書体 NP-R", "Noto Sans JP",
    "Lucida Sans Regular", "Lucida Grande", "Lucida Sans Unicode", Geneva,
    Verdana, sans-serif;
  width: 760px;
}
#print .literal {
  font-family: "UD デジタル 教科書体 NP-R", "Noto Sans JP";
  font-size: 100px;
  width: 32px;
}
#kanji-table {
  width: 100%;
}
#kanji-table th,
#kanji-table td {
  border: 1px solid #aaaaaa;
}
#kanji-table th {
  background: #9a9a9a;
  color: white;
  font-weight: normal;
}
.spacer {
  height: 80px;
}
.example {
  margin-top: 32px;
}
hr {
  margin-top: 32px;
  border-top: 1px solid #aaaaaa;
  border-bottom: 0;
}

.print-pdf {
  width: 720px;
  text-align: left;
  margin-top: 16px;
  margin-left: 16px;
}
</style>
